const FREE_LOOKUPS_OPERATOR = {
  is_equal_to: "=",
  is_greater_than: ">",
  is_less_than: "<"
}

const isOpenBound = (value) => value === null || value === undefined || value === ""

// The filter bar keeps the shared Filters shapes; the backend names are `name`, `free_count` and
// `applied`. `free_lookups` is serialized here because `serializeData` passes whole-number filters
// through as objects.
export const serializeLookupFilters = ({ pricing_schema, free_lookups, applied } = {}) => {
  const params = {}

  if (Array.isArray(pricing_schema) && pricing_schema.length && !pricing_schema.includes("all")) {
    params.name = pricing_schema.join(",")
  }

  if (Array.isArray(applied) && applied.length === 1) {
    params.applied = applied[0]
  }

  if (free_lookups?.type === "is_between") {
    const { min, max } = free_lookups

    if (!isOpenBound(min) || !isOpenBound(max)) {
      params.free_count = `${isOpenBound(min) ? "" : min},${isOpenBound(max) ? "" : max}`
    }
  } else if (FREE_LOOKUPS_OPERATOR[free_lookups?.type] && !isOpenBound(free_lookups.min)) {
    params.free_count = `${FREE_LOOKUPS_OPERATOR[free_lookups.type]} ${free_lookups.min}`
  }

  return params
}
